import { API_BASE_URL, ENABLE_AUTH } from '../utils/constants';

async function parseJsonSafe(response) {
  try {
    return await response.json();
  } catch (_error) {
    return null;
  }
}

function buildError(payload, fallbackMessage) {
  const error = new Error(
    payload?.error?.message || payload?.message || fallbackMessage || 'Request failed.'
  );
  error.code = payload?.error?.code || 'REQUEST_FAILED';
  error.payload = payload;
  return error;
}

async function requestJson(path, { method = 'GET', body, clerkToken } = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      ...(clerkToken ? { Authorization: `Bearer ${clerkToken}` } : {}),
      'Content-Type': 'application/json',
    },
    credentials: ENABLE_AUTH ? 'include' : 'omit',
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const payload = await parseJsonSafe(response);
  if (!response.ok) {
    throw buildError(payload, 'Unable to start customer portal session.');
  }

  return payload?.data || payload || {};
}

export function exchangeCustomerPortalClerkSession({ clerkToken }) {
  return requestJson('/customer-auth/web/clerk/exchange', {
    method: 'POST',
    clerkToken,
    body: {},
  });
}

export function fetchCustomerPortalWebSession() {
  return requestJson('/customer-auth/web/session', { method: 'GET' });
}

export function logoutCustomerPortalWebSession() {
  return requestJson('/customer-auth/web/logout', {
    method: 'POST',
    body: {},
  });
}
